//@flow
import React, { useState } from 'react';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';

type Props = {
  data: Object<dataPropTypes>,
};
export type dataPropTypes = {
  result_news_data: Object<newsDataProps>,
};
export type newsDataProps = {
  id: number,
  title: string,
  description: string,
  mobile_picture: string,
  pdf_file?: any,
  published_on: string,
  media_path_thumbnail_mobile: string,
};
const NewsSectionMobile = (props: Props) => {
  const { height, isMobile } = useViewport();
  const { result_news_data } = props.data;
  const { sectionHeading } = props;

  const [sliderRef, setSlider] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const handleSliderRef = ref => {
    setSlider(ref);
  };

  return (
    <div
      className="news-section-mobile-body"
      style={isMobile ? { height } : {}}
    >
      {/*<CallToAction*/}
      {/*  className={'section-header-item'}*/}
      {/*  text={'VIEW ALL'}*/}
      {/*  onClick={() => {}}*/}
      {/*/>*/}
      <div className="news-publication-inner-section">
        <h2 className="title">{sectionHeading} </h2>
        {result_news_data ? (
          <HorizontalCarousel
            data={Array.isArray(result_news_data) ? result_news_data : []}
            type={'news-card-mobile'}
            cssFor={'news-card-mobile'}
            getActiveSlide={e => {
              setActiveSlide(e);
            }}
            handleSliderRef={handleSliderRef}
          />
        ) : null}
      </div>
    </div>
  );
};
export default NewsSectionMobile;
